<template>
    <BModal :model-value="modal" scrollable centered title="Payment Method" hide-footer @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Payment Method</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <div class="form-group">
                <BFormSelect type="text" 
                v-model="paymentMethodForm.type" 
                :options="typeOptions" 
                
                
                >
                    <template #first>
                        <BFormSelectOption :value="null" disabled>
                            Select Payment Type
                        </BFormSelectOption>
                    </template>
                </BFormSelect>
            </div>
            <div class="form-group">
                <BFormInput type="text" v-model="paymentMethodForm.name" placeholder="Name"></BFormInput>
            </div>
            <div class="form-group">
                <BFormInput type="text" v-model="paymentMethodForm.number" placeholder="Number or code"></BFormInput>
            </div>
            <div class="form-group">
                <BFormInput type="text" v-model="paymentMethodForm.owned_by" placeholder="Owned BY"></BFormInput>
            </div>
        </BForm>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2">{{ paymentMethodData && paymentMethodData.uuid ? 'Update' : 'Save'}}</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template> 
    </BModal>
</template>

<script>
import { BModal, BFormInput,BButton, BForm, BFormSelect, BFormSelectOption } from 'bootstrap-vue-next';
import { ref, inject, watch } from 'vue';

export default {
    components: {
        BModal,
        BFormInput,
        BButton,
        BForm,
        BFormSelect,
        BFormSelectOption,
    },
    props: {
        modal: Boolean,
        paymentMethodData: Object,
    },
    emits: ["update:modal"],
    setup(props, { emit }) {
        const repositories = inject('repositories');
        const paymentMethodRepository = repositories ? repositories.paymentMethod : null;
        const paymentMethodForm = ref({
            name: '',
            type : null,
            number: '',
            owned_by: '',
        });

        const typeOptions = [
        { value: 'tunai', text: 'Tunai' },
            { value: 'bank_transfer', text: 'Bank Transfer' },
            { value: 'credit', text: 'Credit' },
        ];

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        }

        const handleAction =  () => {
            props.paymentMethodData.uuid ? update() : create()
        }

        const create = async () => {
            await paymentMethodRepository.create(paymentMethodForm.value).then(() => {
                updateModal(false)
                paymentMethodForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        const update = async () => {
            await paymentMethodRepository.update(paymentMethodForm.value, props.paymentMethodData.uuid).then(() => {
                updateModal(false)
                paymentMethodForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        watch(() => props.paymentMethodData, (newData) => {
            if (newData) {
                paymentMethodForm.value = { ...newData };
            }
        }, { immediate: true });

        return {
            paymentMethodForm,
            updateModal,
            handleAction,
            create,
            update,
            typeOptions,
        }
    }
}
</script>


